import { render, staticRenderFns } from "./KFoundationsList.vue?vue&type=template&id=8fd0d446&"
import script from "./KFoundationsList.vue?vue&type=script&lang=js&"
export * from "./KFoundationsList.vue?vue&type=script&lang=js&"
import style0 from "./KFoundationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports